// extracted by mini-css-extract-plugin
export var error = "j_K";
export var fieldTitle = "j_J";
export var fiveStar = "j_L";
export var ratingContainer = "j_F";
export var ratingSpacer = "j_H";
export var ratingSubContainer = "j_G";